var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2C20 0.89543 19.1046 0 18 0H6C4.89543 0 4 0.89543 4 2V8H2C0.89543 8 0 8.89543 0 10V16C0 18.2091 1.79086 19.978 4 19.978V20H17C18.6569 20 20 18.6569 20 17V2ZM2 10H4V16C4 16 4 18 3 18C2 18 2 16.5947 2 16V10ZM6 16.017V10V2H18V17L17.9933 17.1166C17.9355 17.614 17.5128 18 17 18H7.00193H5.00696C5.76905 18 6 16.017 6 16.017ZM15 3C16.1046 3 17 3.89543 17 5V7C17 8.10457 16.1046 9 15 9H9C7.89543 9 7 8.10457 7 7V5C7 3.89543 7.89543 3 9 3H15ZM15 5H9V7H15V5ZM15.5 10.5C16.0523 10.5 16.5 10.9477 16.5 11.5C16.5 12.0128 16.114 12.4355 15.6166 12.4933L15.5 12.5H8.5C7.94772 12.5 7.5 12.0523 7.5 11.5C7.5 10.9872 7.88604 10.5645 8.38338 10.5067L8.5 10.5H15.5ZM16.5 15.5C16.5 14.9477 16.0523 14.5 15.5 14.5H8.5L8.38338 14.5067C7.88604 14.5645 7.5 14.9872 7.5 15.5C7.5 16.0523 7.94772 16.5 8.5 16.5H15.5L15.6166 16.4933C16.114 16.4355 16.5 16.0128 16.5 15.5Z",
    fill: "#162941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/articles.94f4d9be8ae55f0bb7c8e8d26c7d4085.svg";
export { ForwardRef as ReactComponent };